export default "__VITE_ASSET__0a75cc80__"